import { motion } from "motion/react";
import { Link } from "@tanstack/react-router";
import ritualImage from "@/assets/ritual.jpg?format=webp&quality=72";
import { ResponsiveImage } from "@/components/responsive-image";
import { SIZES } from "@/lib/image-sources";

export function Ritual() {
  return (
    <section id="ritual" className="relative grain overflow-hidden">
      <ResponsiveImage
        src={ritualImage}
        alt="A tarnished brass mortar, amber bottles, an open formula notebook, resins and dried botanicals on dark stone"
        width={1920}
        height={1088}
        sizes={SIZES.hero}
        pictureClassName="contents"
        className="absolute inset-0 h-full w-full object-cover"
      />

      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(90deg, oklch(0.13 0.01 60 / 0.2) 0%, oklch(0.13 0.01 60 / 0.55) 45%, oklch(0.13 0.01 60 / 0.95) 100%)",
        }}
      />

      <div className="relative z-10 mx-auto flex max-w-7xl justify-end px-6 py-32 sm:py-44">
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-lg text-right"
        >
          <p className="eyebrow">The Method</p>
          <h2 className="mt-6 text-3xl leading-tight text-parchment sm:text-4xl lg:text-5xl">
            Tinctured, rested,
            <br />
            <span className="italic text-gold/90">filtered, bottled.</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-foreground/85 sm:text-xl">
            Each composition is built from natural materials, macerated slowly,
            filtered by hand, and released in small seasonal batches. No
            shortcuts. No constant restocks. Only what the materials allow.
          </p>

          <div className="ornament mt-8 justify-end">
            <span>✶</span>
          </div>
          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-3 border border-gold/60 px-9 py-4 font-display text-xs uppercase tracking-[0.26em] text-parchment transition-colors duration-500 hover:bg-gold hover:text-primary-foreground"
          >
            Read the Method
          </Link>

        </motion.div>
      </div>
    </section>
  );
}
